var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[(_vm.order.status=='paid')?_c('v-btn',{on:{"click":function($event){$event.stopPropagation();return _vm.confirm()}}},[_vm._v("Confirmer la commande")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }